import { useMemo } from 'react';
import { v4 } from 'uuid';

/**
 * Create a memoized uuid. To be replaced by useId from React 18.
 *
 * Useful for linking accessible elements:
 *
 * const labelledBy = useId();
 *
 * <svg aria-labelledby={labelledBy}>
 *  <title id={labelledBy}>My Title</title>
 * </svg>
 */
export default function useId(): string {
  return useMemo(() => v4(), []);
}
